import React from 'react';
import { useSelector } from 'react-redux';

import Link from '@swf/components/Link/Link';
import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import Translation from '@swf/components/Translation/Translation';
import { ResolverTag } from '@swf/core/enums';
import useResolver from '@swf/core/hooks/useResolver';
import { select } from '@swf/core/store';

import {
  TXTWCL_Gambling_is_supposed_to_be_fun_ELL,
  TXTWCL_If_itXs_notX_Xa_hrefXXN0XXConn_ELL
} from './RegulatoryHeaderCAON.messages.json';
import styles from './RegulatoryHeaderCAON.scss';
import IGamingEn from './assets/igaming-en.svg';
import IGamingFr from './assets/igaming-fr.svg';

const RegulatoryHeaderCAON: React.FC = () => {
  const iGamingOntario = useResolver(ResolverTag.IGamingOntario);
  const locale = useSelector(select.locale.get);

  return (
    <div className={styles.regulatoryHeader}>
      <p className={styles.regulatoryText}>
        <Translation {...TXTWCL_Gambling_is_supposed_to_be_fun_ELL} />{' '}
        <Translation
          values={{
            a: (msg: string) => (
              <ResolverLink resolverTag={ResolverTag.ConnexOntario}>{msg}</ResolverLink>
            )
          }}
          {...TXTWCL_If_itXs_notX_Xa_hrefXXN0XXConn_ELL}
        />
      </p>
      <Link href={iGamingOntario} isCrossPlatform openLinkInNewTab>
        {locale === 'fr' ? (
          <IGamingFr width={95} height={30} />
        ) : (
          <IGamingEn width={95} height={30} />
        )}
      </Link>
    </div>
  );
};

export default RegulatoryHeaderCAON;
